import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import { IEventCollectionItem } from "../../interfaces"
import { ScrollList, StyledButton, Text } from "../."
import { UpcomingEventCard } from "./UpcomingEventCard"

interface IUpcomingEventsProps {
	events: IEventCollectionItem[]
}

export const UpcomingEvents = observer(({ events }: IUpcomingEventsProps) => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return (
		<div className="mb-[25px]">
			<Text variant="large-bold" style="ml-[16px] mb-[16px]">
				{t("home.upcoming")}
			</Text>

			<ScrollList
				horizontal
				items={events}
				renderItem={(item) => (
					<StyledButton onClick={() => navigate(`event/${item._id}`)}>
						<UpcomingEventCard event={item} />
					</StyledButton>
				)}
				listEmptyComponent={<Text>{t("home.no_upcoming_events")}</Text>}
			/>
		</div>
	)
})
